var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-icon-wrap",attrs:{"to":_vm.link}},[_c('img',{staticClass:"nav-icon",attrs:{"src":_vm.imgSrc}}),_c('div',{class:['status',_vm.status]}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }